import AddIcon from '@mui/icons-material/Add';
import PeopleIcon from '@mui/icons-material/People';
import {
  BooleanField,
  Button,
  ChipField,
  Datagrid,
  DateField,
  Link,
  List,
  ReferenceArrayField,
  ReferenceField,
  SingleFieldList,
  TextField,
  TopToolbar,
  usePermissions,
  useRecordContext,
} from 'react-admin';
import { Role_Enum } from 'src/utils/enum';
import Aside from './Aside';
import KeyViewEmbedded from './KeyViewEmbedded';

export const KeyViewIcon = PeopleIcon;

const KeyActions = () => (
  <TopToolbar>
    <Button label="ADD KEY MANUALLY" startIcon={<AddIcon />} component={Link} to={{ pathname: '/key/create' }} />
  </TopToolbar>
);
const Group = () => {
  const record = useRecordContext();
  const { permissions } = usePermissions();
  return (
    <ReferenceArrayField label="Groups" source="group_ids" reference="group">
      <SingleFieldList linkType={false}>
        {[Role_Enum.Master, Role_Enum.Superuser].includes(permissions) ? (
          <Link to={`/key/${record.id}`}>
            <ChipField source={'name'} />
          </Link>
        ) : (
          <ChipField source={'name'} />
        )}
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

Group.defaultProps = { label: 'Lock' };

const KeyViewList = () => {
  const { permissions } = usePermissions();
  return (
    <List
      actions={
        [Role_Enum.Master, Role_Enum.Superuser].includes(permissions) ? <KeyActions /> : <TopToolbar></TopToolbar>
      }
      // filter={{ 'departure_date@_gte': moment().format('YYYY-MM-DD') }}
      sort={{ field: 'created_at', order: 'DESC' }}
      aside={<Aside />}
      exporter={false}
    >
      <Datagrid
        expand={[Role_Enum.Master, Role_Enum.Superuser].includes(permissions) ? <KeyViewEmbedded /> : <> </>}
        rowClick="expand"
        optimized
      >
        <TextField source="id" />
        <TextField source="full_name" />
        {permissions === Role_Enum.Master && (
          <ReferenceField label="Confirmation" source="reservation_id" reference="reservation">
            <TextField source="confirmation_number" />
          </ReferenceField>
        )}
        <TextField source="status" />
        <BooleanField source="is_sent_mail" />
        <TextField source="number" />
        <Group />
        <DateField source="arrival_time" showTime locales="de-AT" />
        <DateField source="departure_time" showTime locales="de-AT" />
        {permissions === Role_Enum.Master && <DateField source="updated_at" showTime locales="de-AT" />}
      </Datagrid>
    </List>
  );
};

export default KeyViewList;
